export default "__VITE_ASSET__234975d3__"